import axios from 'axios';

export default {
  namespaced: true,

  state: {
    haveActivePermissions: false,
    users: [],
    permits: [],
    ownPermits: [],
    teacherPermits: [],
    scannedUser: null,
    refParentScroll: null,
    totalPage: 0,
    totelPagePermits: 0,
    viewCount: 0,
    totalCount: 0
  },

  getters: {
    getUsers: s => s.users,
    getPermits: s => s.permits,
    getOwnPermits: s => s.ownPermits,
    getTeacherPermits: s => s.teacherPermits,
    getTotalPage: s => s.totalPage,

    getScannedUser: s => s.scannedUser,
    refParentScroll: s => s.refParentScroll
  },

  mutations: {
    SET_TOTAL_PAGE(state, value) {
      state.totelPagePermits = value;
    },
    SET_TOTAL_PAGE_PERMITS(state, value) {
      state.totalPage = value;
    },
    SET_TOTAL_COUNT(state, value) {
      state.totalCount = value;
    },
    SET_VIEW_COUNT(state, value) {
      state.viewCount = value;
    },
    SET_REF_PARENT_SCROLL(state, ref) {
      state.refParentScroll = ref;
    },
    SET_COMMON(state, [namespace, value]) {
      state[namespace] = value;
    },
    SET(state, [namespace, value]) {
      state[namespace] = [...value];
    },
    SET_SCANNED_USER(state, data) {
      state.scannedUser = { ...data };
    }
  },

  actions: {
    fetchUsers({ rootState, commit }, params = {}) {
      params.campus_id = rootState.settings.selectedCampus.id;
      this.$service
        .retrieve(this.$services.security.users, { params })
        .then(r => {
          commit('SET_TOTAL_PAGE', r.data.meta.last_page);
          commit('SET_VIEW_COUNT', r.data.meta.to);
          commit('SET_TOTAL_COUNT', r.data.meta.total);
          commit('SET', ['users', r.data.data]);
        });
    },
    fetchPermits({ rootState, commit }, params = {}) {
      params.campus_id = rootState.settings.selectedCampus.id;
      axios
        .get('/api/security/permits/', { params })
        .then(r => {
          commit('SET', ['permits', r.data]);
        })
        .catch(e => {
          console.log(e);
        });
    },

    fetchOwnPermits({ rootState, commit }, params = {}) {
      params.campus_id = rootState.settings.selectedCampus.id;
      axios
        .get('/api/security/own-permits/', { params })
        .then(r => {
          commit('SET', ['ownPermits', r.data]);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchTeacherPermits({ rootState, commit }, params = {}) {
      params.campus_id = rootState.settings.selectedCampus.id;
      axios
        .get('/api/exit-permission-teacher/', { params })
        .then(r => {
          commit('SET', ['teacherPermits', r.data.data]);
          commit('SET_TOTAL_PAGE', r.data.last_page);
        })
        .catch(e => {
          console.log(e);
        });
    },
    fetchTeacherPermitsPagination(
      { rootState, rootGetters, commit },
      params = {}
    ) {
      params.campus_id = rootState.settings.selectedCampus.id;
      const permits = rootGetters['security/getTeacherPermits'];

      axios
        .get('/api/exit-permission-teacher/', { params })
        .then(r => {
          commit('SET', ['teacherPermits', [...permits, ...r.data.data]]);
          commit('SET_TOTAL_PAGE', r.data.last_page);
          console.log(permits, 'rootGetters');
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
